import { libraryGameDay, weekLabel } from "../../../lib/practiceWeek.ts";
import type { LibraryGame } from "./adapter.ts";

/**
 * A game's practice week in the Game Library: the Monday-to-Sunday week its
 * day falls in, "Nov 2 - 8, 2026" (client 2026-11-04). Not picked or typed;
 * moving the game to another day (Date column) moves it to that day's week.
 * `day`: the day the Date cell beside it shows (a pick still saving among
 * them), so the two always agree; else the game's own.
 */
export function GameWeekCell({ game, day, today }: { game: LibraryGame; day?: string | null; today?: string }) {
  return <>{weekLabel(day ?? libraryGameDay(game, today))}</>;
}
